import { ArrowRightAlt } from '../../utils/editorReactIcons';
export { ArrowRightAlt };
export default ArrowRightAlt;
